export default "__VITE_ASSET__D4JAF2CD__"